import React from 'react';

export function InputUserForm({error, type, placeholder = '', name, value, disabled, onChange}) {

  return <input type={type}
                name={name}
                className={"tabs__input input" + (error ? " input--error" : "")}
                placeholder={placeholder}
                value={value}
                disabled={disabled}
                onChange={onChange}/>;
}
